import React from "react";
import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";
import { ActiveMessengerContainer } from "../../components/ActiveMessengerContainer/ActiveMessengerContainer";

const ActiveTelegramScreen = () => {
  return (
    <ScreenLayout>
      <ActiveMessengerContainer messenger={"telegram"} />
    </ScreenLayout>
  );
};

export default ActiveTelegramScreen;
